import { Alert } from '@mm/components';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { activeChatbotSelector } from '@mm/state/selectors/viewSelectors';
import React, { useEffect, useState } from 'react';
import SelectTimezone from '@capaj/react-select-timezone';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import CheckBox from '../../../../../../../common/components/Checkbox';
import { WeekDayPicker } from '../WeekDayPicker/WeekDayPicker';
import styles from './TimezoneAndWeekDayPicker.module.css';

type Props = {
  className?: string;
  useCheckboxStyle?: boolean;
};

export const TimezoneAndWeekDayPicker = ({
  className,
  useCheckboxStyle,
}: Props) => {
  const activeChatbot = useSelector(activeChatbotSelector);
  const activeFacebookPage = useSelector(activeFacebookPageSelector);
  const chatBotFromBot = activeChatbot.businessHours?.timezone || '';
  const [selectedTimezone, setSelectedTimezone] = useState(chatBotFromBot);

  useEffect(() => setSelectedTimezone(chatBotFromBot), [chatBotFromBot]);
  const [isDailyEdit, setIsDailyEdit] = useState<undefined | boolean>(
    undefined,
  );

  const showTimezoneNotSetAlert =
    !!activeFacebookPage &&
    !!activeChatbot?.useAwayResponder &&
    selectedTimezone === '';
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.switchContainer}>
        <CheckBox
          className={styles.switchCheckbox}
          isChecked={!!isDailyEdit}
          onToggle={() => setIsDailyEdit(!isDailyEdit)}
        />
        <span>Set different hours per day of week</span>
      </div>
      {showTimezoneNotSetAlert && (
        <Alert type="error" className={styles.alert} showCloseIcon={false}>
          Please select a time zone in order to use Away Responder
        </Alert>
      )}
      <div className={styles.timezone}>
        <div className={styles.timezoneText}>Your timezone:</div>
        <div className={styles.timezoneWrapper}>
          <SelectTimezone
            className={showTimezoneNotSetAlert && styles.timezoneError}
            value={selectedTimezone}
            onChange={(tz: string) => setSelectedTimezone(tz)}
            guess
          />
        </div>
      </div>
      <WeekDayPicker
        selectedTimezone={selectedTimezone}
        isDailyEdit={isDailyEdit}
        setIsDailyEdit={setIsDailyEdit}
        useCheckboxStyle={useCheckboxStyle}
      />
    </div>
  );
};
